var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-not-found"},[_c('h1',[_vm._v(" "+_vm._s(_vm.isOnCouncilPage ? "No cases were found for this council." : "Page not found.")+" ")]),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Back to home")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }